module.exports = __webpack_public_path__ + "static/img/14gejuyaoda.c11dff96.gif";